<script setup lang="ts">
import type { NewsList } from '@/store/News'
import { PropType } from 'vue'

const props = defineProps({
  news: {
    type: Object as PropType<NewsList>,
    required: true,
  },
  type: {
    type: String,
    default: 'v1',
  },
})

const categoryLowCase = props.news.category.toLocaleLowerCase()
</script>
<template>
  <div class="news-image" :class="`${categoryLowCase} news-image--${props.type}`">
    <LazyLoadImage :src="news.imageThumbnail" class="news-image__image"></LazyLoadImage>
  </div>
</template>

<style lang="scss" scoped>
.news-image {
  position: relative;
  margin-bottom: 5px;
  overflow: hidden;
}

.news-image__image {
  width: 100%;
  height: 200px;
  background: center center/ cover;
  transition: all 0.2s;
}

.news-image--v2 {
  .news-image__image {
    height: 130px;
  }
}

@media #{$maxDesktop} {
  .news-image__image {
    height: 250px;
  }
}

@media #{$tablet} {
  .news-image__image {
    height: 200px;
  }
}
@media #{$mobile} {
  .news-image__image {
    height: 130px;
  }
  .news-category {
    font-size: 0.9em;
  }
}

@media (max-width: 500px) {
  .news-image--v2 {
    .news-image__image {
      height: 100px;
    }
  }
}
</style>
